<template>
    <div class="ip-basics-tab mb-lg">
        <AonSpinner v-if="loading" class="mx-auto" :scale="0.5" color="castleMoat" />
        <div v-else-if="entityStore.patentBreakdown?.length > 1" class="card-holder">
            <WorldViewCard />
            <AonContainer>
                <AonRow class="mt-sm">
                    <AonCol class="grid-cols-6 py-sm pl-0 pr-sm">
                        <MoatQualityCard />
                        <ClaimBreathCard class="pt-lg" />
                    </AonCol>
                    <AonCol class="grid-cols-6 py-sm pr-0 pl-sm">
                        <PatentAnalysisCard />
                    </AonCol>
                </AonRow>
                <AonRow>
                    <AonCol class="grid-cols-12">
                        <CORVizCard />
                    </AonCol>
                </AonRow>
            </AonContainer>
        </div>
        <div v-else>
            <AonContainer>
                <AonRow>
                    <AonCol class="grid-cols-12 flex-column justify-center">
                        <AonCard title="No Patents" :desc="noPatentsFoundMsg"> </AonCard>
                    </AonCol>
                </AonRow>
            </AonContainer>
        </div>
    </div>
</template>

<script setup>
import { watch, ref, onMounted, inject, computed } from 'vue'
import { useEntityStore } from '@/stores'
import { useRoute } from 'vue-router'

import WorldViewCard from './WorldViewCard.vue'
import ClaimBreathCard from './ClaimBreathCard.vue'
import PatentAnalysisCard from './PatentAnalysisCard.vue'
import CORVizCard from './CORVizCard.vue'
import MoatQualityCard from './MoatQualityCard.vue'
import AonCard from '@moatmetrics/armory/src/components/base/AonCard.vue'

const entityStore = useEntityStore()
const route = useRoute()
const entityId = route.params.targetPk

const loading = computed(() => {
    return entityStore.loadingEntity || !entityStore.patentBreakdown
})

const noPatentsFoundMsg = computed(() => {
    return 'No patents identified for ' + entityStore.entity.name + '.'
})
</script>

<style lang="scss" scoped></style>
